var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 40.9999C78.4996 48.919 75.9922 56.6347 71.3372 63.0412C66.6822 69.4477 60.1186 74.2161 52.587 76.663C45.0554 79.1099 36.9425 79.1097 29.411 76.6624C21.8795 74.2151 15.3162 69.4463 10.6615 63.0395C6.00688 56.6327 3.49994 48.9169 3.5 40.9978C3.50006 33.0787 6.00711 25.3628 10.6618 18.9561C15.3166 12.5494 21.88 7.78075 29.4115 5.33354C36.943 2.88632 45.0559 2.88621 52.5875 5.33322",
    stroke: "#194383",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.4f23271a30a989df16fa234e22d8302d.svg";
export { ForwardRef as ReactComponent };